import { useCallback, useEffect, useState } from 'react';
import {
  loadTutorialProgressFromStorage,
  saveTutorialProgressToStorage,
  updateTutorialProgressArray,
} from '@/utils/tutorials/tutorials';
import type { Tutorial, TutorialProgress } from './Landingpage.types';

export const useLandingPageTutorials = (allTutorials: Tutorial[]) => {
  const [tutorialProgress, setTutorialProgress] = useState<TutorialProgress[]>(
    [],
  );

  useEffect(() => {
    const loadedProgress = loadTutorialProgressFromStorage(allTutorials);
    setTutorialProgress(loadedProgress);
  }, [allTutorials]);

  const handleTutorialStart = useCallback((tutorialId: string) => {
    console.error('[useLandingPageTutorials] Tutorial started:', tutorialId);
  }, []);

  const handleTutorialStepComplete = useCallback(
    (tutorialId: string, stepId: string) => {
      console.error(
        '[useLandingPageTutorials] Tutorial step completed:',
        tutorialId,
        stepId,
      );
    },
    [],
  );

  const handleTutorialComplete = useCallback((tutorialId: string) => {
    console.error('[useLandingPageTutorials] Tutorial completed:', tutorialId);
  }, []);

  const handleTutorialProgressUpdate = useCallback(
    (progress: TutorialProgress) => {
      setTutorialProgress((prev) =>
        updateTutorialProgressArray(prev, progress),
      );
      try {
        saveTutorialProgressToStorage(progress);
      } catch {
        // Error is already logged in utility function
      }
    },
    [],
  );

  return {
    tutorialProgress,
    handleTutorialStart,
    handleTutorialStepComplete,
    handleTutorialComplete,
    handleTutorialProgressUpdate,
  };
};
